import React from 'react';

import { useSelector } from 'react-redux';

import ItemLink from 'components/Layouts/Admin/Dashboard/Navigation/ItemLink';
import BackLink from 'components/Layouts/Form/Header/shared/BackLink';
import MainHeader from 'components/Layouts/shared/MainHeader';
import { SETTINGS_STEP_NAMES, SETTINGS_STEP_PATHS, useSettingsContext } from 'components/Pages/Admin/Settings/context';
import { useAccountPath } from 'hooks/useAccountPath';
import { currentAccountSelector, isAccountFulfilledSelector } from 'store/user/selectors';

import baseStyles from '../index.module.css';

const SettingsHeader = () => {
  const getPath = useAccountPath();
  const { steps, backButton } = useSettingsContext();
  const isAccountFulfilled = useSelector(isAccountFulfilledSelector);
  const account = useSelector(currentAccountSelector);

  return (
    <MainHeader
      backLink={
        backButton.available && (
          <BackLink href={backButton.link} id={backButton?.id}>
            {backButton.text}
          </BackLink>
        )
      }
      links={steps.map((step, idx) => {
        return (
          <ItemLink
            key={step}
            href={getPath(SETTINGS_STEP_PATHS[step])}
            noMargin
            exact
            className={baseStyles.link}
            linkClassName={baseStyles.tab}
            disabled={idx !== 0 && !isAccountFulfilled}
          >
            {typeof SETTINGS_STEP_NAMES[step] == 'function'
              ? SETTINGS_STEP_NAMES[step](account)
              : SETTINGS_STEP_NAMES[step]}
          </ItemLink>
        );
      })}
    />
  );
};

export default SettingsHeader;
